import { SafariObject } from '../../base-object/models/app/safari-object-base';
import { TransferDialogOptions } from '../../redux/file-operation';

export class FileObject extends SafariObject {
  // file is declared as optional because sometimes you might want to just pass the ID for deletes, for example
  file?: File;
  // I don't think this should be part of FileObject. This should be in those actionOptions for the file.
  shouldUseTus?: boolean;
  // Name to override with. This is currently used only in matters, as that's the only case where we can change file names,
  // but I can see this being used in other places in the future. So as long as the way they do it in the API
  // stays consistent, we can keep it here, together with the default adapter.
  name?: string;
}
export type FileObjectForTransferDialog<T = FileObject> = T & { transferDialogOptions?: TransferDialogOptions };
export const INVALID_FILE_CHARACTERS = '["<>|:*?\\/]';
export const INVALID_FILE_CHARACTERS_MESSAGE = 'Name cannot contain ' + INVALID_FILE_CHARACTERS.replace('[', '').replace(']', '').split('').join(' ');
